import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"
import { UserId } from "../id"
import { CoinTransaction } from "./user-private"

export const CoinTransactionDocumentMeta = z.object({
  user_id: z.string(),
  transaction: CoinTransaction,
  amount: z.number(),
})

export type CoinTransactionDocumentMeta = z.infer<typeof CoinTransactionDocumentMeta>

export const CoinTransactionDocumentBody = z.intersection(
  CoinTransactionDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type CoinTransactionDocumentBody = z.infer<typeof CoinTransactionDocumentBody>

export type CoinTransactionDocument = CoinTransactionDocumentBody & {
  id: string,
  user_id: UserId,
}

export class CoinTransactionDocuments {

  static toDocumentData(doc: CoinTransactionDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): CoinTransactionDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      user_id: UserId(data["user_id"]),
      transaction: data["transaction"],
      amount: data["amount"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
